export const testPasswordLength = (password: string) => {
  const regex = /^[A-Za-z\d@$!%*?&#,./_<>+='~;:"`~{}()^[\]|\\-]{8,}$/;

  return regex.test(password);
};

export const testPasswordContainsUppercaseLetter = (password: string) => {
  const regex = /[A-Z]/;

  return regex.test(password);
};

export const testPasswordContainsNumber = (password: string) => {
  const regex = /\d/;

  return regex.test(password);
};

export const testPasswordContainsSpecialCharacter = (password: string) => {
  const regex = /[@$!%*?&#,./_<>+=';:"`~{}()^[\]|\\-]/;

  return regex.test(password);
};
